module.exports = __webpack_public_path__ + "images/icons/flags/NO-3a6087db.svg";